import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { disableScrolling, enableScrolling } from '../utils/helpers';

gsap.registerPlugin(ScrollTrigger);
class Header {
  constructor(wWidth) {
    this.wWidth = wWidth;
    this.isOrderOpened = false;
    this.headerOpened = false;

    this.$header = $('.header');
    this.$hamburger = this.$header.find('.hamburger');
    this.$order = this.$header.find('.header__order');
    this.$orderBtn = this.$order.find('.header__order-btn');
    this.$warmerGreySections = $('.warmer-grey-section');
    this.$fullWidthHero = $('.full-width-media--hero');
    this.$mediaStorytellerMobileFull = $(
      '.media-storyteller--mobile-full .media-storyteller__media-wrapper'
    );

    this.init();
    this.initColorChange();
  }

  init() {
    // toggle mobile nav
    this.$hamburger.on('click', () => {
      this.headerOpened = !this.headerOpened;
      this.$header.toggleClass('is-opened');

      if (this.wWidth >= 768) return;
      if (this.headerOpened) {
        disableScrolling();
      } else {
        enableScrolling();
      }
    });

    // order button
    this.$orderBtn.on('click', () => {
      this.isOrderOpened = !this.isOrderOpened;
      this.$header.toggleClass('is-order-opened');
    });

    this.$order.on('click', (e) => {
      e.stopPropagation();
    });
  }

  onClick() {
    // if order opened, close it
    if (this.isOrderOpened) {
      this.isOrderOpened = false;
      this.$header.removeClass('is-order-opened');
    }
  }

  initColorChange() {
    // header color changes
    // if full width hero
    if (this.$fullWidthHero.length) {
      this.$header.addClass('is-light');

      ScrollTrigger.create({
        trigger: this.$fullWidthHero.get(0),
        start: 'top 100px',
        end: 'bottom 100px',
        onEnter: () => {
          this.$header.removeClass('is-scrolling');
        },
        onLeave: () => {
          this.$header.addClass('is-scrolling');
        },
        onEnterBack: () => {
          this.$header.removeClass('is-scrolling');
        },
        onLeaveBack: () => {
          this.$header.addClass('is-scrolling');
        },
      });
    } else if (this.$mediaStorytellerMobileFull.length) {
      ScrollTrigger.create({
        trigger: this.$mediaStorytellerMobileFull.get(0),
        start: 'top 100px',
        end: 'bottom 100px',
        onEnter: () => {
          if (this.wWidth < 768) {
            this.$header.removeClass('is-scrolling');
          }
        },
        onLeave: () => {
          this.$header.addClass('is-scrolling');
        },
        onEnterBack: () => {
          if (this.wWidth < 768) {
            this.$header.removeClass('is-scrolling');
          }
        },
        onLeaveBack: () => {
          this.$header.addClass('is-scrolling');
        },
      });
    } else {
      this.$header.addClass('is-scrolling');
    }

    // change color on warmer grey sections
    this.$warmerGreySections.each((i, el) => {
      if (el.classList.contains('horizontal')) return;
      ScrollTrigger.create({
        trigger: el,
        start: 'top 100px',
        end: 'bottom 100px',
        toggleClass: {
          targets: this.$header,
          className: 'is-warmer-grey',
        },
      });
    });
  }

  onResize(wWidth) {
    this.wWidth = wWidth;

    // if header opened, close it
    if (this.headerOpened) {
      this.headerOpened = false;
      this.$header.removeClass('is-opened');
      enableScrolling();
    }
  }
}

export default Header;
